import {Component, Input} from '@angular/core';
import {CommonsModule} from '../../../common/common.module';
import {MdProgressSpinnerModule} from 'ng-uikit-pro-standard';
import {NgIf} from '@angular/common';
import {InterventionTeamDetailDto} from '../../intervention-teams/teams/intervention-team-detail.dto';

@Component({
  selector: 'app-intervention-team-card',
  templateUrl: './intervention-team-card.component.html',
  styleUrl: './intervention-team-card.component.scss',
})
export class InterventionTeamCardComponent {
  @Input()
  public team: InterventionTeamDetailDto;

  protected get firstContact() {
    return this.team?.assignedContacts?.[0];
  }

  protected get contactEmail(): string {
    return this.firstContact?.email || 'No contacts in this team.';
  }



}
